import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App.tsx";
import { isPublicRoute, isPrivateRoute } from "./lib/prerender-routes";
import "./index.css";

export const createRoot = ViteReactSSG({ routes });

/** Public pages and private landing pages get their own static HTML; the sitemap only lists public ones. */
export const includedRoutes = (paths: string[]) =>
  paths.filter((p) => isPublicRoute(p) || isPrivateRoute(p));
